import * as React from 'react';
import Log from '../../lib/log';
import { useRef, useState } from 'react';
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Button,
  Stack,
} from '@mui/material';
import { v2apiBlob } from '../../api/axios';
// import { useSelector } from '../../store/store';
import { useEffect } from 'react';

// ログの初期化
const log = new Log('ResponseText');

interface Props {
  responseText: string | undefined;
  responseVoiceType: number;
  handleResponseTextChange: (responseText: string) => void;
  handleVoiceTypeChange: (voiceType: number) => void;
}

export default function ResponseTextContent(props: Props) {
  log.putLog('info', 'ResponseText started.');

  // ストアからユーザー情報を取得
  // const user = useSelector((state) => state.loginUser.user);
  const [responseError, setResponseError] = useState(false);

  useEffect(() => {
    setVoiceType(props.responseVoiceType);
  }, [props.responseVoiceType]);

  // 応答メッセージ
  const inputResponseRef = useRef<any>(null);
  const handleResponseChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    // エラーチェック
    if (inputResponseRef.current.value.trim() === '') {
      setResponseError(true);
    } else {
      setResponseError(false);
    }
    props.handleResponseTextChange(inputResponseRef.current.value);
  };

  // 再生ボタン
  const [voiceType, setVoiceType] = useState(0);
  const [voiceTypeDisable, setVoiceTypeDisable] = useState(false);
  const handlePlayClick = async (e: any) => {
    setVoiceTypeDisable(true);
    // 音声データに変換
    const postData = {
      text: inputResponseRef.current.value,
      voiceType: voiceType.toString(),
    };
    const res = await v2apiBlob.post('/text-to-speech', postData);
    const blobUrl = URL.createObjectURL(new Blob([res.data]));
    const audio = new Audio(blobUrl);
    audio.addEventListener('ended', (e: any) => {
      setVoiceTypeDisable(false);
    });
    audio.load();
    audio.play();
  };

  // 音声タイプ
  const handleVoiceTypeChange = (e: any) => {
    setVoiceType(e.target.value);
    props.handleVoiceTypeChange(e.target.value);
  };

  return (
    <Grid container spacing={2} alignContent='center'>
      <Grid item xs={12} md={9} lg={9}>
        <TextField
          error={responseError}
          inputProps={{ minLength: 1 }}
          inputRef={inputResponseRef}
          fullWidth
          id='response'
          multiline
          rows={10}
          defaultValue={props.responseText}
          onChange={handleResponseChange}
        />
      </Grid>
      <Grid item xs={12} md={3} lg={3}>
        <Stack spacing={2}>
          <FormControl sx={{ m: 0, minWidth: '100%' }} size='small'>
            <InputLabel id='voice-type-select'>性別</InputLabel>
            <Select
              labelId='voice-type-select'
              id='voice-type-select'
              value={voiceType}
              label='性別'
              onChange={handleVoiceTypeChange}
            >
              <MenuItem value={0}>男性</MenuItem>
              <MenuItem value={1}>女性</MenuItem>
            </Select>
          </FormControl>
          <Button
            variant='outlined'
            color='primary'
            size='small'
            onClick={handlePlayClick}
            disabled={voiceTypeDisable}
          >
            テスト
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
}
